import { TextField } from "../components/TextField";
import { Button } from "../components/Button";
import { Select } from "../components/Select";
import { Form, redirect, useNavigation } from "react-router-dom";
import { addCustomer, getMembershipPlans, getModels } from "../services/api";
import { useEffect, useState } from "react";
import { getUserId, getUserPermission } from "../services/helpers";
import mixpanel from "../services/mixpanel";



export async function AddCustomerAction ({request}){
	const data = await request.formData();
	const formToJSON = {};

	for (const [key, value] of [...data.entries()]) {
		formToJSON[key] = value;
	}
	const response = await addCustomer(formToJSON);
	const responseCopy = response.clone();
	try{


		// if (!response.ok) {
		// 	throw new Error('Network response was not ok');
		// }

		const result = await response.json();
		// console.log("result",result);

		return redirect(`/dashboard/members/u/${result.customer_id}/vehicles`);
	} catch(e){
		console.log("response copy",await responseCopy.text());
	}
}

export function AddMember(){
	const [isMember, setIsMember] = useState(false);
	const [hasCar, setHasCar] = useState(true);
	const [forceDetails, setForceDetails] = useState(false);
	const userPermission = getUserPermission();
	const [_models,_setModels] = useState([]);
	const [_plans,_setPlans] = useState([]);
	const navigation = useNavigation();
	const isSubmitting = navigation.state === "submitting";

	useEffect(()=>{
		mixpanel.identify(getUserId());
		getModels().then((response)=>{
			let tempList = [];
			response.models.forEach((model)=>{
				tempList.push(model.vehicle_name);
			});
			_setModels(tempList);


		getMembershipPlans().then((plans_response)=>{
			let tempList_ = [];
			plans_response.plans.forEach((plan)=>{
				tempList_.push(plan.plan_name);
			});
			_setPlans(tempList_);
		});
	});


},[]);
	return (
	<main id="AddMember">
		<h1>Add A Customer</h1>

		<Form method="post"  encType="multipart/form-data">
			{/* Member bio card  */}
			<div className="card">
				<p className="label">Customer Bio</p>
				<div className="row" id="member-bio-grid">

					 {/*<TextField
					name="customer_image"
					label="Customer Image"
					type="file"
					/>
					<TextField
					name="vehicle_image"
					label="Vehicle Image"
					type="file"
					/>*/}
					{/* <div className="col">
						<TextField
						label="Occupation"
						name="occupation"
						// value='entrepeneur'
						/>
					</div> */}

					<TextField
					label="First Name"
					// value="kweku"
					name="first_name"
					required={true}
					/>
					<TextField
					label="Last Name"
					name="last_name"
					required={true}
					// value="acquaye"
					/>
					<TextField
					label="Other Names"
					name="other_names"
					subLabel="(Optional)"
					/>


					<TextField
					label="Phone Number"
					name="phone_number"
					subLabel="(Optional)"
					// required={true}
					// value="0559582518"
					/>
					<TextField
					label="Email"
					name="email"
					subLabel="(Optional)"
					// value="kwekuaacquaye@gmail.com"
					/>
					<TextField
					label="Location"
					name="location"
					subLabel="(Optional)"
					// value="east legon"
					/>


				</div>

			</div>

			{/* Vehicle Details  */}
			<div className="card">
				<div className="row">

					<div className="checkbox-div">
						<input type="checkbox" name="has_car" id="has_car" checked={hasCar} onChange={()=>setHasCar(prev=>!prev)}/>
						<label htmlFor="has_car">Has a car </label>
					</div>
					{userPermission !== "basic" && <div className="checkbox-div">
						<input type="checkbox" name="force_details" id="force_details" checked={forceDetails} onChange={()=>setForceDetails(prev=>!prev)}/>
						<label htmlFor="force_details">Force Details </label>
					</div>}
				</div>

				<div style = { {display: hasCar ? "block" : "none"}}>
					<p className="label">Vehicle Details</p>
					<div className="row space-between">
						<TextField
						label="Vehicle Brand & Model"
						name="vehicle_make"
						required={hasCar && !forceDetails}
						datalist={_models}
						// value="Hundai Elantra"
						style={{"width": "35vw"}}
						/>
						<TextField
						label="License Plate"
						name="license_plate"
						required={hasCar && !forceDetails}
						// value="GR 5663 24"
						style={{"width":"25vw"}}
						/>
					</div>
					<div className="row" id="vd_2">


						<TextField
						label="Year of Manufacture"
						width="15vw"
						// value="2025"
						name="year_manufacture"
						required={hasCar && !forceDetails}
						// required={true}
						/>
						<Select
						label="Engine Capacity"
						width="20vw"
						name="capacity"
						options={["1.0L-1.8L","2.0L-2.7L","3.0L-3.4L","3.5L-3.9L"]}
						/>
						<TextField
						label="Color"
						width="15vw"
						name="colour"
						subLabel="(Optional)"
						// value="Blue"
						/>
						<TextField
						label="Mileage"
						style={{"width":"15vw"}}
						subLabel="(Optional)"
						// value="4000"
						name="milage"
						/>
					</div>

					<TextField
						label="Vehicle Identification Number"
						subLabel="(Optional)"
						name="vin"
						// value="49430394039403949"
						style={{"width":"35vw"}}
						/>

						<div className="row" style={{justifyContent:'space-between', marginTop: "4em"}}>
							<TextField
								label="Insurance Provider"
								subLabel="(Optional)"
								width="25vw"
								name="insurance_provider"
								/>
							<TextField
								label="Insurance Expiry"
								subLabel="(Optional)"
								type={"date"}
								// width="15vw"
								name="insurance_expiry"
								/>
							<TextField
								label="Roadworthy Expiry"
								subLabel="(Optional)"
								type={"date"}
								// width="15vw"
								name="roadworthy_expiry"
							/>

						</div>

				</div>
			</div>

			<div className="card">
				<div className="checkbox-div">
					<input type="checkbox" name="is_member" id="is_member" checked={isMember} onChange={()=>setIsMember(!isMember)}/>
					<label htmlFor="is_member">Is A member</label>
				</div>
				<div style = { {display: isMember ? "block" : "none"}}>
					<p className="label">Membership Details</p>
					<div className="row" style={{justifyContent:"space-between",}}>



					<TextField
							label="Member Id"
							name="member_id"
							subLabel="(Leave empty to autogenerate)"
						/>

						<Select
						label="Membership Plan"
						name="plan"
						options={_plans}
						/>
						<Select
							label="Renewal Schedule"
							name="schedule"
							options={['quarter',"bianual","year"]}
						/>
						<TextField
							label="Start Date"
							type="date"
							name="start_date"
							style={{width: "15vw"}}
						/>
					</div>
					<div className="row" >
						<TextField
							label="Assigned FITA Buddy"
							name="buddy"
							style={{"width":"35vw"}}
						/>

						{/* <TextField
							style={{"width":"35vw"}}
							label="Prefered Medium"
							name="medium"
						/> */}
					</div>
				</div>

			</div>

			<Button
			label={isSubmitting ? "Submitting Data" :" Add a member"}
			color={isSubmitting? "green" :"blue"}
			type="submit"
			id="addMemberButton"
			disabled={isSubmitting}
			/>
		</Form>
	</main>)
}